// GATHER PRIORITY (Roger 2026-08-08) — the ALWAYS rule for ordering any candidate pool we gather from
// eBay: FOREIGN parts first, DOMESTIC last. The app concentrates on what SELLS; most domestic parts
// don't sell, so they're low priority — if credits run out, domestics are what gets skipped. This is the
// SINGLE source of truth so every scan orders the same way and it can't drift (do NOT re-order by $).
export const DOMESTIC_MAKES = new Set([
  "FORD", "CHEVROLET", "CHEVY", "GMC", "DODGE", "JEEP", "CHRYSLER", "RAM",
  "BUICK", "CADILLAC", "LINCOLN", "PONTIAC", "SATURN", "MERCURY", "OLDSMOBILE", "HUMMER", "PLYMOUTH",
]);

export function isDomesticMake(make: string | null | undefined): boolean {
  return DOMESTIC_MAKES.has((make ?? "").toString().trim().toUpperCase());
}

// Stable sort: foreign (0) before domestic (1). getMake pulls the make string from an item.
export function sortForeignFirst<T>(items: T[], getMake: (item: T) => string | null | undefined): T[] {
  return [...items].sort((a, b) => (isDomesticMake(getMake(a)) ? 1 : 0) - (isDomesticMake(getMake(b)) ? 1 : 0));
}
